<mp-entity-list-head
  [count]="(catalogs() | filterCatalogsBy: searchTerm()).length"
  [searchTerm]="searchTerm()"
  (searched)="emitSearched($event)"
>
  @if (allowSort()) {
    <mp-entity-list-head-action-button label="Hinzufügen" icon="add" (actionClick)="handleAddItemsClicked()" />
  }
</mp-entity-list-head>

<mp-sortable-katalog-list
  invertArrowKeys
  [kataloge]="catalogs() | filterCatalogsBy: searchTerm()"
  [allowSort]="searchTerm().length === 0"
  [maxIndex]="catalogs().length"
  (itemSorted)="emitItemSorted($event)"
  (itemRemoved)="emitItemRemoved($event)"
  (itemsAdded)="emitItemsAdded($event)"
  (industriekatalogClicked)="emitIndustriekatalogClicked($event)"
/>
